import { h, Component } from 'preact';
import {Form} from 'components/elements' 
import PatientSelectHorizontal from './PatientSelectHorizontal'
import PatientSelectVertical from './PatientSelectVertical'
import GenericPatientSelectHorizontal from './GenericPatientSelectHorizontal'
import GenericPatientSelectVertical from './GenericPatientSelectVertical'
import style from './style.less'
import {connect} from 'react-redux'
import { SelectedPatientActions } from 'actions';

@Form
@connect((state)=>({
	...state
}))
export default class PatientSelect extends Component {
	constructor(){
        super()
        this.handlePatientSelect = this.handlePatientSelect.bind(this)
    }

    handlePatientSelect(patient){
        const selectedPatientIDs = Object.keys(this.props.selectedPatients)
        if(selectedPatientIDs.indexOf(patient.id) == -1){
            SelectedPatientActions.append(patient)
        }else{
            SelectedPatientActions.remove(patient)
        }
        
        this.props.onPatientSelect && this.props.onPatientSelect(patient)
    }

	render(){
		return (
            this.props.layout == 'horizontal' ?
                this.props.loading.patients?
                    <div class={style.patientSpinner}>
                        <i class={`fa fa-spinner fa-spin`} aria-hidden="true"></i>
                    </div>
                :
                    this.props.config.genericPatients ?
                        <GenericPatientSelectHorizontal 
                            onPatientSelect={this.handlePatientSelect} 
                        />
                    :
                        <PatientSelectHorizontal 
                            onPatientSelect={this.handlePatientSelect} 
                        />
            :
                this.props.config.genericPatients ?
                    <GenericPatientSelectVertical 
                        onPatientSelect={this.handlePatientSelect} 
                    />
                :
                    <PatientSelectVertical 
                        onPatientSelect={this.handlePatientSelect} 
                    />
		);
	}
}



// WEBPACK FOOTER //
// ./components/partials/PatientSelect/index.js